module.exports = __webpack_public_path__ + "media/images/Branding/HW-aed4e6c16ebc1c3b58db68f2ade2a24e.png";